require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-tax-resource-center-tax-prep-savings.json") })
        }
      }, "path---es-tax-resource-center-tax-prep-savings");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-tax-resource-center-tax-prep-savings!./.cache/json/es-tax-resource-center-tax-prep-savings.json
// module id = 2621
// module chunks = 231608221292675